'use client';

import { Tabs } from '@zillow/constellation-10';
import React from 'react';
import { useTranslations } from 'next-intl';
import { constellationTabBackgroundOverride } from '@/src/styles/constellationTabs.styles';
import type { BedroomOption } from './hooks/useFloorplansByBedroom';

type BedroomTabsProps = {
  options: Array<BedroomOption>;
  activeBeds: number;
  onTabChange: (beds: number) => void;
};

export const BedroomTabs = ({ options, activeBeds, onTabChange }: BedroomTabsProps) => {
  const t = useTranslations('hdp');

  return (
    <Tabs.Root
      selected={String(activeBeds)}
      onSelectedChange={(value) => onTabChange(Number(value))}
      css={constellationTabBackgroundOverride}
    >
      <Tabs.List aria-label={t('filterByBedrooms')}>
        {options.map((o) => (
          <Tabs.Tab
            key={o.beds}
            value={String(o.beds)}
            data-testid={`tab-${o.beds === 0 ? 'studio' : `${o.beds}-${o.beds === 1 ? 'bed' : 'beds'}`}`}
          >
            {o.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs.Root>
  );
};
